export type PreviewDevice = "ipadPortrait" | "ipadLandscape" | "iphone"
export type PreviewScreen = "home" | "scan"

export const previewDeviceLabel: Record<PreviewDevice, string> = {
  ipadPortrait: "iPad Portrait",
  ipadLandscape: "iPad Landscape",
  iphone: "iPhone",
}

export const previewScreenLabel: Record<PreviewScreen, string> = {
  home: "Home Screen",
  scan: "Scan Screen",
}
